// module_configs/electronics.js
import React from 'react';
import { 
  faGaugeHigh, faUsers, faUserPlus, faUsersLine, faBuilding, faUserTie,
  faBuildingUser, faUserGroup, faIdCard, faCubes, faCube, faListAlt,
  faTruckFast, faCartPlus, faFileInvoice, faReceipt, faArrowRotateLeft,
  faRotateLeft, faListCheck, faQrcode, faPrint, faCartShopping, faClipboardList,
  faArrowRightArrowLeft, faMoneyBillWave, faPlus, faGear, faBullhorn,
  faLayerGroup, faBoxes, faCog, faMicrochip, faUsersCog, faClock
} from '@fortawesome/free-solid-svg-icons';

// Import Electronics components
import DashboardHome from '.././module_cosmetics/cosmetics_homedash';

import AddCustomer from '.././module_mechanics/mechanics_customer';

import CustomerList from '.././module_mechanics/mechanics_customer_list';

import AddSupplier from '.././module_mechanics/mechanics_Supplier';

import SupplierList from '.././module_mechanics/mechanics_SuppliersList';

import AddEmployee from '.././module_mechanics/mechanics_employees';

import MecEmployeeList from '.././module_mechanics/mechanic_employeelist';

import ElectronicsProducts from '.././module_electronics/electronics_products';

import ElectronicsProductsList from '.././module_electronics/electronics_productslist';

import ElectronicsPurchases from '.././module_electronics/electronics_Purchases';

import ElectronicsPurchaseList from '.././module_electronics/electronics_PurchaseList';

import ElectronicsReturn from '.././module_electronics/electronics_Return';

import ElectronicsReturnList from '.././module_electronics/electronics_returnlist';

import ElectronicsSell from '.././module_electronics/electronics_Sell';

import ElectronicsSalesList from '.././module_electronics/electronics_SellList';

import MechanicsBarcode from '.././module_mechanics/mechanics_BarcodeGenerator';

import RootUsers from '.././module_roots/RootUsers';

import MessageSystem from '.././module_roots/MessageSystem';

import AddTransactionForm from '.././module_cosmetics/cosmetics_addtransactions';

import CosmeticsTransactions from '.././module_cosmetics/cosmetics_transactions';

import CosmeticsSupplierPurchases from '.././module_cosmetics/cosmetics_PurchasesSupplierwise';

import CosmeticsInvoicePurchaseList from '.././module_cosmetics/cosmetics_InvoicePurchaseList';
import ElectronicsSupplierPurchases from '../module_electronics/electronics_PurchasesSupplierwise';
import ElectronicsInvoicePurchaseList from '../module_electronics/electronics_InvoicePurchaseList';

export const electronicsConfig = {
  moduleId: 'electronics',
  moduleName: 'Electronics',
  icon: faMicrochip,
  description: 'Electronics Shop Management System',
  
  dashboardComponent: DashboardHome,
  
  roles: {
    'admin_electronics': { level: 1, label: 'Admin', color: '#0ea5e9' },
    'manager_electronics': { level: 2, label: 'Manager', color: '#0284c7' },
    'user_electronics': { level: 3, label: 'User', color: '#0369a1' },
    'viewer_electronics': { level: 4, label: 'Viewer', color: '#075985' }
  },
  
  menuGroups: [
    { id: 'management', name: 'Management', icon: faUsersCog, order: 1 },
    { id: 'inventory', name: 'Inventory & Stock', icon: faBoxes, order: 2 },
    { id: 'sales', name: 'Sales & Transactions', icon: faMoneyBillWave, order: 3 },
    { id: 'system', name: 'System Settings', icon: faCog, order: 4 }
  ],
  
  menus: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faGaugeHigh,
      component: DashboardHome,
      roles: ['all'],
      groupId: 'management',
      position: 0
    },
    {
      id: 'customers',
      label: 'Customers',
      icon: faUsers,
      roles: ['admin_electronics', 'manager_electronics', 'user_electronics'],
      groupId: 'management',
      position: 1,
      submenus: [
        {
          id: 'addcustomer',
          label: 'Add Customer',
          component: AddCustomer,
          icon: faUserPlus,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        },
        {
          id: 'customerlist',
          label: 'Customer List',
          component: CustomerList,
          icon: faUsersLine,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        }
      ]
    },
    {
      id: 'suppliers',
      label: 'Suppliers',
      icon: faBuilding,
      roles: ['admin_electronics', 'manager_electronics', 'user_electronics'],
      groupId: 'management',
      position: 2,
      submenus: [
        {
          id: 'addsupplier',
          label: 'Add Supplier',
          component: AddSupplier,
          icon: faUserTie,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        },
        {
          id: 'supplierlist',
          label: 'Supplier List',
          component: SupplierList,
          icon: faBuildingUser,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        }
      ]
    },
    {
      id: 'employees',
      label: 'Employees',
      icon: faUserGroup,
      roles: ['admin_electronics', 'manager_electronics'],
      groupId: 'management',
      position: 3,
      submenus: [
        {
          id: 'addemployees',
          label: 'Add Employee',
          component: AddEmployee,
          icon: faUserPlus,
          roles: ['admin_electronics', 'manager_electronics']
        },
        {
          id: 'employeeslist',
          label: 'Employees List',
          component: MecEmployeeList,
          icon: faIdCard,
          roles: ['admin_electronics', 'manager_electronics']
        }
      ]
    },
    {
      id: 'stock',
      label: 'Stock',
      icon: faCubes,
      roles: ['admin_electronics', 'manager_electronics', 'user_electronics'],
      groupId: 'inventory',
      position: 4,
      submenus: [
        {
          id: 'addstock',
          label: 'Add Stock',
          component: ElectronicsProducts,
          icon: faCube,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        },
        {
          id: 'stocklist',
          label: 'Stock List',
          component: ElectronicsProductsList,
          icon: faListAlt,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        }
      ]
    },
    {
      id: 'purchases',
      label: 'Purchase',
      icon: faTruckFast,
      roles: ['admin_electronics', 'manager_electronics', 'user_electronics'],
      groupId: 'inventory',
      position: 5,
      submenus: [
        {
          id: 'addpurchase',
          label: 'New Purchase',
          component: ElectronicsPurchases,
          icon: faCartPlus,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        },
        {
          id: 'purchaselist',
          label: 'Purchases List',
          component: ElectronicsPurchaseList,
          icon: faFileInvoice,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        },
        {
          id: 'purchasessupplierwise',
          label: 'Supplier-wise',
          component: ElectronicsSupplierPurchases,
          icon: faBuilding,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        },
        {
          id: 'purchasesinvoicewise',
          label: 'Bill-wise',
          component: ElectronicsInvoicePurchaseList,
          icon: faReceipt,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        }
      ]
    },
    {
      id: 'returns',
      label: 'Returns',
      icon: faArrowRotateLeft,
      roles: ['admin_electronics', 'manager_electronics', 'user_electronics'],
      groupId: 'inventory',
      position: 6,
      submenus: [
        {
          id: 'addreturn',
          label: 'New Return',
          component: ElectronicsReturn,
          icon: faRotateLeft,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        },
        {
          id: 'returnlist',
          label: 'Return List',
          component: ElectronicsReturnList,
          icon: faListCheck,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        }
      ]
    },
    {
      id: 'sales',
      label: 'Sales',
      icon: faCartShopping,
      roles: ['admin_electronics', 'manager_electronics', 'user_electronics'],
      groupId: 'sales',
      position: 7,
      submenus: [
        {
          id: 'addsale',
          label: 'New Sale',
          component: ElectronicsSell,
          icon: faCartPlus,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        },
        {
          id: 'saleslist',
          label: 'Sales List',
          component: ElectronicsSalesList,
          icon: faClipboardList,
          roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
        }
      ]
    },
    {
      id: 'transactions',
      label: 'Transactions',
      icon: faArrowRightArrowLeft,
      roles: ['admin_electronics', 'manager_electronics'],
      groupId: 'sales',
      position: 8,
      submenus: [
        {
          id: 'addtransaction',
          label: 'Add Transaction',
          component: AddTransactionForm,
          icon: faPlus,
          roles: ['admin_electronics', 'manager_electronics']
        },
        {
          id: 'transactionsmanager',
          label: 'Transactions',
          component: CosmeticsTransactions,
          icon: faMoneyBillWave,
          roles: ['admin_electronics', 'manager_electronics']
        }
      ]
    },
    // {
    //   id: 'barcode',
    //   label: 'Barcodes',
    //   icon: faQrcode,
    //   roles: ['admin_electronics', 'manager_electronics', 'user_electronics'],
    //   groupId: 'inventory',
    //   position: 9,
    //   submenus: [
    //     {
    //       id: 'barcodeprinting',
    //       label: 'Barcode Printing',
    //       component: MechanicsBarcode,
    //       icon: faPrint,
    //       roles: ['admin_electronics', 'manager_electronics', 'user_electronics']
    //     }
    //   ]
    // },
    {
      id: 'settings',
      label: 'Settings',
      icon: faGear,
      component: RootUsers,
      roles: ['admin_electronics'],
      groupId: 'system',
      position: 10,
      submenus: []
    },
    {
      id: 'systemupdates',
      label: 'Notifications Center',
      icon: faBullhorn,
      component: MessageSystem,
      roles: ['admin_electronics', 'manager_electronics', 'user_electronics'],
      groupId: 'system',
      position: 11,
      submenus: []
    }
  ],
  
  quickStats: [
    { id: 'todaySales', label: "Today's Sales", icon: 'faChartLine', value: '$2,450' },
    { id: 'products', label: 'Products', icon: 'faBoxes', value: 234 },
    { id: 'customers', label: 'Customers', icon: 'faUsers', value: 112 },
    { id: 'pending', label: 'Pending Orders', icon: 'faClock', value: 5 }
  ],
  
  shortcuts: [
    { key: 'Alt + D', description: 'Dashboard' },
    { key: 'Alt + C', description: 'Add Customer' },
    { key: 'Alt + L', description: 'Customer List' },
    { key: 'Alt + P', description: 'Stock List' },
    { key: 'Alt + S', description: 'New Sale' },
    { key: 'Alt + U', description: 'New Purchase' },
    { key: 'Alt + R', description: 'New Return' },
    { key: 'Alt + E', description: 'Add Employee' },
    { key: 'Ctrl + R / Cmd + R', description: 'Refresh Dashboard Data' },
    { key: 'Alt + H', description: 'Toggle Shortcuts Panel' }
  ]
};